import { FaMagic } from 'react-icons/fa';
import AnswerTypeButton from '../../components/AddQuestions/AnswerTypeButton/AnswerTypeButton';
import DropDownSelect from '../../components/DropdownSelect/DropdownSelect';
import { AnswerTypeEnum } from '../../constants/enums';
import { AIDifficultyId, videoAnswerDifficultyId, weightOptions } from '../../constants/questions';
import { t } from '../../i18n/i18n';
import HorizontalLoader from '../../components/HorizontalLoader/HorizontalLoader';
import { getQuestionTypeButton } from '../../utils/getQuestionTypeButtons';
import DebouncedButton from '../../components/Button/Button';
import { useTranslateTestgroup } from '../../hooks/useTranslateTestgroup';
import { useTranslateTest } from '../../hooks/useTranslateTest';
import QuestionComponentSelector from '../../components/QuestionComponentSelected/QuestionComponentSelected';
import useCreateTestGroup from '../../hooks/useCreateTestGroup';

const TranslateTest = ({ onSaveSuccess }) => {
  const { testgroupWithThemes, translatedTests } = useTranslateTestgroup();

  const { testDifficulty, eachScore } = useCreateTestGroup();

  const {
    testToTranslate,
    generatingSuggestion,
    savingTranslation,
    currentTypeQuestion,
    handleSaveTranslation,
    handleUpdateTranslatedTest,
    handleGenerateSuggestion,
  } = useTranslateTest();

  const isEdit = Boolean(translatedTests?.[testToTranslate?.id]);

  const emtpyHandler = () => {};

  const buttons = getQuestionTypeButton(true);
  const handleSave = async () => {
    await handleSaveTranslation();
    onSaveSuccess();
  };

  return (
    <>
      <div data-testid="modal-translate-test" className="p-2 overflow-y-auto mx-5">
        <div className="w-100 row justify-content-center my-3 d-flex flex-column align-items-center">
          <div className="w-100 d-flex flex-column align-items-center gap-2 pb-2">
            <div className="d-flex align-items-center w-100">
              <input
                placeholder={t('ABM_NAME_INPUT_PLACEHOLDER')}
                value={testToTranslate?.name ?? ''}
                onChange={(e) => handleUpdateTranslatedTest('name', e.target.value)}
                name="name"
                className="mx-2 rounded py-2 text-xs font-weight-bold theme-input-border outline-none  py-1 px-2 outline-none h-10"
              />
              <DropDownSelect
                selectedPlaceholder
                className="ml-0 mr-2"
                placeholder={t('MULTIPLE_SELECT_DIFFICULTY_PLACEHOLDER')}
                setState={(e) => emtpyHandler(e)}
                selected={testToTranslate?.difficultyId}
                options={testDifficulty
                  ?.filter((test) =>
                    [AnswerTypeEnum.CHECK, AnswerTypeEnum.RADIO].includes(currentTypeQuestion)
                      ? test.id !== AIDifficultyId && test.id !== videoAnswerDifficultyId
                      : true
                  )
                  ?.sort((a, b) => a.order - b.order)
                  ?.map((item) => ({
                    id: item.id,
                    name: t(`CREATE_TEST_GROUP_QUESTION_${item.name}`),
                    weight: item.score,
                  }))}
              />
              {testgroupWithThemes && (
                <input
                  placeholder={t('ABM_THEME_INPUT_PLACEHOLDER')}
                  value={testToTranslate?.theme ?? ''}
                  onChange={(e) => handleUpdateTranslatedTest('theme', e.target.value)}
                  name="theme"
                  className="mx-2 rounded py-2 text-xs font-weight-bold theme-input-border outline-none  py-1 px-2 outline-none h-25"
                  data-testid="add-questions-abm-theme-input"
                />
              )}
              <div className="d-flex align-items-center gap-1">
                {Boolean(testToTranslate?.weight) && (
                  <>
                    <span>{t('CREATE_TEST_GROUP_SCORE')}</span>
                    <DropDownSelect
                      selectedPlaceholder
                      setState={emtpyHandler}
                      selected={testToTranslate?.weight}
                      menuClassnames="d-none"
                      options={weightOptions}
                      disabled
                    />
                  </>
                )}
                {eachScore && testToTranslate?.difficultyId && (
                  <p
                    className=" text-xs fit-content mb-0 font-weight-500 px-2"
                    data-testid="add-questions-each-score-p"
                  >
                    {t('CREATE_TEST_GROUP_TEXT_BETWEEN_SCORE').replaceAll(
                      '{score}',
                      testToTranslate?.weight
                    )}
                  </p>
                )}
              </div>

              <DebouncedButton
                type="primary"
                className="d-flex align-items-center rounded-0 justify-content-center ml-5 px-3 py-2 text-xs font-weight-600 text-light  "
                onClick={handleGenerateSuggestion}
                disabled={generatingSuggestion}
              >
                <div className="mt-5">
                  {generatingSuggestion ? (
                    <HorizontalLoader white className="mt-4" />
                  ) : (
                    <span className="d-flex align-items-center gap-1 mb-5 text-white">
                      {t('CREATE_QUESTION_MODAL_TEXT_BUTTON')} <FaMagic />
                    </span>
                  )}
                </div>
              </DebouncedButton>
            </div>
            <div className="d-flex w-100 px-2">
              <textarea
                name="text"
                className={`border-grey-2 border-grey-rounded outline-none w-100  p-2 px-3 text-xs ${
                  !testToTranslate?.explanation ? 'border-red-danger' : ''
                }`}
                rows="3"
                placeholder={t('CREATE_SCREENING_EXPLANATION_PLACEHOLDER')}
                onChange={(e) => handleUpdateTranslatedTest('explanation', e.target.value)}
                value={testToTranslate?.explanation ?? ''}
                maxLength={300}
                data-testid="question-text-explanation"
              />
            </div>
          </div>

          <div className="d-flex w-100 h-100 px-2">
            <div className="w-25 column justify-content-center column align-items-end">
              <div className="empty-buttons" />
              {buttons.map((button, index) => (
                <AnswerTypeButton button={button} index={index} disabled />
              ))}
              <div className="empty-buttons" />
            </div>
            <div className="w-75 ml-2 pt-4 question-to-add-container d-flex flex-column justify-content-between">
              <QuestionComponentSelector
                currentTypeQuestion={currentTypeQuestion}
                testGroupABM
                isTranslateABM
              />
              <div className="w-100 d-flex justify-content-end mt-3">
                {savingTranslation ? (
                  <div className="mt-4">
                    <HorizontalLoader />
                  </div>
                ) : (
                  <button
                    className="mt-4 align-self-end px-3 py-1 text-white text-xs font-weight-bold border-0 outline-none bg-maya-blue"
                    onClick={handleSave}
                    type="button"
                    disabled={!testToTranslate?.explanation}
                    data-testid="add-questions-edit-question-btn"
                  >
                    {t(isEdit ? 'EDIT_TRANSLATE' : 'SAVE_TRANSLATE')}
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TranslateTest;
